module.exports = __webpack_public_path__ + "img/middle-charging-start.f24b3102.png";